export const APP_ID=1943057700
export const SERVER_SECRET='dd070bdd5314c858ed48bd3edc7cef1c'
